export const getUserRole = (userData) => {
    if (userData?.roles.includes(2)) return "admin";
    if (userData?.roles.includes(7)) return "operator";
    return "unknown";
};
